var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLeaderboardActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4105,
    y: -1598,
    width: 11584,
    height: 15424,
    fill: "#5D5CF5",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27 -112H229V788H-27V-112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27 -112H229V788H-27V-112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27 -14H229V16V46H-27V-14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 -8C-20 -12.4183 -16.4183 -16 -12 -16H211C215.418 -16 219 -12.4183 219 -8V8.37548C219 9.7677 219.363 11.1358 220.054 12.3446L222.716 17.0039C222.892 17.3113 222.892 17.6887 222.716 17.9961L220.054 22.6554C219.363 23.8642 219 25.2323 219 26.6245V40C219 44.4183 215.418 48 211 48H-12C-16.4183 48 -20 44.4183 -20 40V-8Z",
    fill: "#5D5CF5",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5E61EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22266 16.2456L15.4505 8.46771C15.7543 8.14097 16.2466 8.14097 16.5503 8.46771L23.7782 16.2456H22.2227V21.8301C22.2227 22.2924 21.8744 22.6671 21.4449 22.6671H19.5004H17.556V17.9195H14.4449V22.6671H10.556C10.1264 22.6671 9.77821 22.2924 9.77821 21.8301V16.2456H8.22266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 850,
    fill: "white",
    transform: "translate(-27 -112)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeaderboardActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/leaderboard-active.5a5b8362.svg";
export { ForwardRef as ReactComponent };